<template lang="pug">
#modal-visualizar-informacao-territorio-monitoramento(
    v-if='show && situacao !== {}'
)
    el-dialog(
        :visible.sync='show',
        :before-close='closeModal',
        :close-on-click-modal='false',
        width='750px'
    )
        .template(slot='title')
            .box-header
                .box-header--icon
                    i.mdi.mdi-alert-outline
                .box-header--title
                    | {{ situacao.camadaCategoria.nome }}
        .conteudo
            .conteudo-esquerda
                h3 {{ $t('mensagens.inteligenciaTerritorial.imovel.situacaoTerritorio') }}
                .conteudo-esquerda-lista(
                    v-if='!situacao.camadaCategoria.codigo.includes("REPRESENTANTES")'
                )
                    DiagnosticoSocioambiental(
                        :dadosConsulta='situacao',
                        :habilitar-sinal-aviso='true',
                        @index-aberto='atualizarRestricaoMapa'
                    )

                .conteudo-esquerda-lista(v-else)
                    .representantes.mt-3(
                        v-for='(representante, index) in situacao.diagnosticoPorRepresentante'
                    )
                        .mb-3
                            .dados-label
                                h4
                                    i.flow.flow-user-second
                                    | {{ $t('mensagens.comuns.pessoa') }}
                            span {{ representante.nomeRepresentante }}
                        DiagnosticoSocioambiental(
                            :dadosConsulta='representante',
                            :habilitar-sinal-aviso='true'
                        )
            .conteudo-direita
                mapa(
                    height='100%',
                    idMapa='MapaModalVisualizarInformacaoTerritorioMonitoramento',
                    :key='keyMapa',
                    :mapLayersConfigs='camadasMapa',
                    :mapConfig='configuracoesMapa',
                    ref='map'
                )
</template>

<script>
import Mapa from '@/components/MapaLeaflet.vue';
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import centroidFromGeoJSON from '@/utils/centroidFromGeoJSON';

export default {
    name: 'ModalVisualizarEmbargosInteligenciaTerritorial',

    props: {
        situacao: {
            type: Object,
            required: true,
            default() {
                return {};
            }
        },
        territorio: {
            type: Object,
            required: true,
            default() {
                return {};
            }
        },
        show: {
            default: false,
            type: Boolean
        }
    },
    emits: ['close'],
    components: {
        Mapa,
        DiagnosticoSocioambiental
    },

    data() {
        return {
            camadasMapa: [],
            configuracoesMapa: {
                controls: {
                    zoomControl: true,
                    camadasControl: true,
                    fullscreen: true
                },
                inspecionar: false,
                diagnostico: false
            },
            keyMapa: 1,
            camadaCentralizadaNome: null,
            indexUltimaRestricaoAberta: null,
            areasRestricao: {},
            geometria: []
        };
    },
    watch: {
        territorio: function () {
            this.geometria = this.territorio;

        },
        show(_new, _old) {
            if (_new) {
                this.configureLayersMapa();
            }
        }
    },

    methods: {
        closeModal() {
            this.camadasMapa = [];
            this.$emit('close');
        },
        configureLayersMapa() {
            this.camadasMapa = [];

            let layerAreaMonitorada = {
                style: {
                    color: '#FFFF00',
                    weight: 1,
                    opacity: 1,
                    fillColor: '#FFFF00'
                },
                name: 'Área Monitorada',
                geoJson: this.geometria
            };
            this.camadasMapa.push(layerAreaMonitorada);
        },

        mostrarAreasDiagnosticoNoMapa(tagRestricao, group, restricao) {
            if (this.areasRestricao.camada !== undefined) {
                const opacidade =
                    this.areasRestricao.camada.opacidade >= 0.0
                        ? this.areasRestricao.camada.opacidade / 200
                        : 0.5;

                this.areasRestricao.areas.forEach((area, index) => {
                    this.camadasMapa.push({
                        style: {
                            color: 'red',
                            weight: 1,
                            fill: true,
                            opacity: opacidade,
                            fillOpacity: opacidade
                        },
                        name: `AreaDiagnostico ${index}`,
                        tagRestricao,
                        group,
                        geoJson: area
                    });

                    const pin = L.icon({
                        iconUrl: 'https://lyra-v1.s3.amazonaws.com/Pin+da+restricao.png',
                        iconSize: [18, 18]
                    });

                    this.camadasMapa.push({
                        name: `CentroidDiagnostico ${index}`,
                        icon: pin,
                        tagRestricao,
                        group,
                        geoJson: centroidFromGeoJSON.get(area)
                    });
                });
            }
        },

        atualizarRestricaoMapa(restricao, indexCollapse, indexCollapseRow) {
            this.areasRestricao = {};

            const tagRestricaoRemove = `${this.indexUltimaRestricaoAberta}-area`;
            this.camadasMapa = this.camadasMapa.filter(
                l => l.tagRestricao !== tagRestricaoRemove
            );

            if (indexCollapseRow !== '') {
                this.indexUltimaRestricaoAberta = indexCollapseRow;
                this.areasRestricao =
                    indexCollapseRow !== '' &&
                    this.situacao.diagnosticos[indexCollapseRow].resultados
                        .length > 0
                        ? {
                              areas: this.situacao.diagnosticos[
                                  indexCollapseRow
                              ].resultados.map(r => r.geometria),
                              camada: this.situacao.diagnosticos[
                                  indexCollapseRow
                              ].camada
                          }
                        : {};

                const tagRestricaoAdd = `${indexCollapseRow}-area`;
                const group = `grupo-restricoes-${indexCollapse}-${indexCollapseRow}`;
                this.mostrarAreasDiagnosticoNoMapa(
                    tagRestricaoAdd,
                    group,
                    restricao
                );
            }
        }
    }
};
</script>

<style lang="scss">
#modal-visualizar-informacao-territorio-monitoramento {
    .el-dialog__wrapper {
        top: -15px !important;
    }
    .el-dialog {
        width: 69% !important;
    }
    .el-dialog__header {
        background: var(--operation-awaiting-approval);
    }
    .box-header {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .box-header--icon {
            margin-right: 10px;
        }
        .box-header--title {
            color: var(--warning);
            font-size: 20px;
        }
        .mdi:before,
        .mdi-set {
            font-size: 19px;
            color: var(--warning);
        }
    }
    .conteudo {
        display: flex;
        height: 500px;
        .conteudo-esquerda {
            width: 40%;
            h3 {
                margin-bottom: 10px;
                color: var(--black);
            }
            .conteudo-esquerda-lista {
                max-height: 475px;
                overflow-y: auto;
                display: flex;
                flex-direction: column;
                margin-right: 10px;

                #diagnostico-socioambiental {
                    display: block;
                }
            }
            .representantes {
                &:first-child {
                    margin-top: 0px !important;
                }

                .dados-label {
                    margin-bottom: 5px;
                    h4 {
                        margin-top: 10px;
                        color: var(--black);
                        i {
                            padding-right: 5px;
                        }
                    }
                }
            }
        }
        .conteudo-direita {
            width: 60%;
        }
    }
}
</style>
